import { Link } from 'react-router-dom'

/**
 * Shared disclaimer footer — used on every page.
 * `variant` controls styling:
 *   - "minimal"  (default): compact links + disclaimer for app pages / auth pages
 *   - "full": includes Powered-by row + logo, used on Landing page
 */
export default function Footer({ variant = 'minimal' }) {
  if (variant === 'full') {
    return (
      <footer className="border-t border-border">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
          <div className="flex flex-wrap items-center justify-center gap-6 mb-8 pb-8 border-b border-border">
            <span className="text-white/40 text-xs uppercase tracking-wider">Powered by</span>
            {['Coinbase', 'Stripe', 'Telnyx', 'CoinGecko'].map((name) => (
              <span key={name} className="text-white/60 text-sm font-medium">{name}</span>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-2.5">
              <img src="/logo-transparent.png" alt="" className="w-6 h-6 object-contain" />
              <span className="text-white font-display text-sm tracking-wide">ALRTZ</span>
              <span className="text-white/40 text-xs">&copy; {new Date().getFullYear()}</span>
            </div>

            <div className="flex items-center gap-6 text-white/50 text-xs">
              <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
              <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
            </div>
          </div>

          <p className="text-white/30 text-[10px] text-center mt-6">
            ALRTZ is not advice. Use at your own risk.
          </p>
        </div>
      </footer>
    )
  }

  // minimal variant
  return (
    <div className="px-4 sm:px-6 py-4 border-t border-border">
      <div className="flex items-center justify-center gap-4 text-white/30 text-[10px]">
        <Link to="/terms" className="hover:text-white/60 transition-colors">Terms</Link>
        <Link to="/privacy" className="hover:text-white/60 transition-colors">Privacy</Link>
        <Link to="/contact" className="hover:text-white/60 transition-colors">Contact</Link>
      </div>
      <p className="text-white/20 text-[10px] text-center mt-1">ALRTZ is not advice. Use at your own risk.</p>
    </div>
  )
}
